import {
    defaultIndicationOfDanger,
    defaultFilterIndicationsOfDangerSga,
} from "./state";

/**
 * Mutación que lista las indicaciones de peligro de SGA .
 *
 * @param {*} state.indicationsOfDangerSga - Estado de las indicaciones de peligro de SGA.
 * @param indicationsOfDangerSga - Indicaciones de peligro de SGA.
 * @return {void}
 * @author Brandon Torres
 */
export function setIndicationsOfDangerSga(state, indicationsOfDangerSga) {
    state.indicationsOfDangerSga = indicationsOfDangerSga;
}

/**
 * Mutación que establece la acción a realizar (Crear o actualizar).
 *
 * @param {*} state.action - Estado de la acción.
 * @param action - Acción a realizar (create o edit).
 * @return {void}
 * @author Brandon Torres
 */
export function setActionIndicationOfDangerSga(state, action) {
    state.action = action;
}

/**
 * Mutación que establece la indicación de peligro por defecto.
 *
 * @param {*} state.indicationOfDanger - Estado de la indicación de peligro.
 * @return {void}
 * @author Brandon Torres
 */
export function setDefaultIndicationOfDangerSga(state) {
    state.indicationOfDanger = defaultIndicationOfDanger();
}

/**
 * Mutación que establece el filtro de las indicaciones de peligro de SGA por defecto.
 *
 * @param {*} state.filterIndicationsOfDangerSga - Estado del filtro de las indicaciones de peligro de SGA.
 * @return {void}
 * @author Brandon Torres
 */
export function setDefaultFilterIndicationsOfDangerSga(state) {
    state.filterIndicationsOfDangerSga = defaultFilterIndicationsOfDangerSga();
}

/**
 * Mutación que establece la cantidad de indicaciones de peligro por página.
 *
 * @param {*} state.filterIndicationsOfDangerSga.per_page - Cantidad de registros por página.
 * @param {*} state.filterIndicationsOfDangerSga.page - Página actual.
 * @param per_page - Cambio de cantidad de registros por página.
 * @return {void}
 * @author Brandon Torres
 */
export function loadAfterChangeSizePagination(state, per_page) {
    state.filterIndicationsOfDangerSga = {
        ...state.filterIndicationsOfDangerSga,
        page: 1,
        per_page: per_page,
    };
}

/**
 * Mutación que establece la página actual.
 *
 * @param {*} state.filterIndicationsOfDangerSga.page - Página actual.
 * @param page - Cambio de página actual.
 * @return {void}
 * @author Brandon Torres
 */
export function loadAfterChangePagePagination(state, page) {
    state.filterIndicationsOfDangerSga.page = page;
}

/**
 * Mutación que establece el paginador de registros de indicaciones de peligro.
 *
 * @param {*} state.filterIndicationsOfDangerSga.page - Página actual.
 * @param {*} state.filterIndicationsOfDangerSga.per_page - Cantidad de registros por página.
 * @param {*} state.filterIndicationsOfDangerSga.total - Total de registros.
 * @param paginate - Paginación de registros.
 * @return {void}
 * @author Brandon Torres
 */
export function setPaginateIndicationsOfDangerSga(state, paginate) {
    state.filterIndicationsOfDangerSga = {
        ...state.filterIndicationsOfDangerSga,
        page: paginate.current_page,
        per_page: paginate.per_page,
        total: paginate.total,
    };
}

/**
 * Mutación que establece la indicación de peligro de SGA.
 *
 * @param {*} state.indicationOfDanger - Estado de la indicación de peligro.
 * @param indicationOfDanger - Indicación de peligro de SGA.
 * @return {void}
 * @author Brandon Torres
 */
export function setIndicationOfDangerSga(state, indicationOfDanger) {
    state.indicationOfDanger = {
        id: indicationOfDanger.id,
        name: indicationOfDanger.name,
        code: indicationOfDanger.code,
        sga_danger_indication_code_languages:
            indicationOfDanger.sga_danger_indication_code_languages,
        parent_danger_indication_codes:
            indicationOfDanger.parent_danger_indication_codes,
        sga_prudence_tip_codes: indicationOfDanger.sga_prudence_tip_codes,
    };
}

/**
 * Mutación que establece las indicaciones de peligro activas de SGA.
 *
 * @param {*} state.activeIndicationsOfDangerSga - Estado de las indicaciones de peligro activas de SGA.
 * @param activeIndicationsOfDangerSga - Indicaciones de peligro activas de SGA.
 * @return {void}
 * @author Brandon Torres
 */
export function setActiveIndicationsOfDangerSga(
    state,
    activeIndicationsOfDangerSga
) {
    state.activeIndicationsOfDangerSga = activeIndicationsOfDangerSga;
}
